module.exports = __webpack_public_path__ + "img/elicottero.3d3edfed.svg";